import { render } from "./field.vue?vue&type=template&id=27ea20fa"
import script from "./field.vue?vue&type=script&lang=js"
export * from "./field.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/form/field.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27ea20fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27ea20fa', __exports__)) {
    console.log('reload')
    api.reload('27ea20fa', __exports__)
  }
  
  module.hot.accept("./field.vue?vue&type=template&id=27ea20fa", () => {
    console.log('re-render')
    api.rerender('27ea20fa', render)
  })

}


export default __exports__